(function() {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {        
        this.addEventListener('load', function() {        
            if(this.status === 401){
                window.location = '/login';
            }

        });
        origOpen.apply(this, arguments);
    };
})();